import { doc, getDoc, updateDoc, increment } from 'firebase/firestore';
import { db } from '../firebase';

export const getCatalogFileUrl = async () => {
  try {
    const docRef = doc(db, 'settings', 'catalog_file');
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      const data = docSnap.data();
      return data.url || null;
    }
    
    return null;
  } catch (error) {
    console.error('Error fetching catalog file URL:', error);
    return null;
  }
};

export const downloadCatalogFile = async () => {
  try {
    const fileUrl = await getCatalogFileUrl();
    
    if (fileUrl) {
      // Track download count
      const docRef = doc(db, 'settings', 'catalog_file');
      await updateDoc(docRef, {
        downloadCount: increment(1),
        lastDownloaded: new Date().toISOString()
      });
      
      // Create a temporary link element to trigger download
      const link = document.createElement('a');
      link.href = fileUrl;
      link.target = '_blank';
      link.download = 'Kalaratans_Gifts_Catalog.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return true;
    } else {
      console.warn('No catalog file available for download');
      return false;
    }
  } catch (error) {
    console.error('Error downloading catalog file:', error);
    return false;
  }
};
